module.exports = __webpack_public_path__ + "static/patriciawork1-110cd7045df761da9e32fce9ad734a76.jpg";